import errors from './errors/index.js';
import translation from './translation/index.js';
const it = Object.freeze({
    translation,
    errors,
});
export default it;
